import { useRef, useState } from 'react';
import heartIcon from './assets/heart-icon.png';
import orgWordmark from './assets/org-wordmark.png';

const UNDERLINE = (
  <svg className="door-underline" viewBox="0 0 220 10" preserveAspectRatio="none" aria-hidden="true">
    <path d="M2 6 C 40 2, 90 9, 130 5 S 190 2, 218 6" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

const DOORS = [
  {
    key: 'meeting',
    title: '担当者会議録用',
    desc: '6部署の記録を、部署ごとの書式ですばやく整理します',
    screen: 'meeting',
    icon: (
      <svg className="door-icon" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 30 L34 30 L31 43 L17 43 Z" />
        <path d="M24 30 L24 15" />
        <path transform="translate(24,24) rotate(-38)" d="M0,0 C 3.6,-4 3.6,-10.3 0,-14.3 C -3.6,-10.3 -3.6,-4 0,0 Z" fill="currentColor" stroke="none" />
        <path transform="translate(24,18) rotate(34)" d="M0,0 C 3.9,-4.4 3.9,-11.2 0,-15.5 C -3.9,-11.2 -3.9,-4.4 0,0 Z" fill="currentColor" stroke="none" />
        <path transform="translate(24,13) rotate(-6)" d="M0,0 C 3.4,-3.8 3.4,-9.8 0,-13.5 C -3.4,-9.8 -3.4,-3.8 0,0 Z" fill="currentColor" stroke="none" />
        <path transform="translate(24,27) rotate(60)" d="M0,0 C 2.6,-2.9 2.6,-7.5 0,-10.4 C -2.6,-7.5 -2.6,-2.9 0,0 Z" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    key: 'conference',
    title: '各種会議用',
    desc: '活動アップや委員会など、種別は自由に追加できます',
    screen: 'conference',
    icon: (
      <svg className="door-icon" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M24 9 C 18 5, 10 5, 6 7 L6 39 C 10 37, 18 37, 24 41" />
        <path d="M24 9 C 30 5, 38 5, 42 7 L42 39 C 38 37, 30 37, 24 41" />
        <path d="M24 9 L24 41" />
        <path d="M11 16 L19 16 M11 22.5 L19 22.5 M29 16 L37 16 M29 22.5 L37 22.5" />
      </svg>
    ),
  },
  {
    key: 'facesheet',
    title: '新規利用者用',
    desc: 'フェースシート情報のまとめ（項目確定後に公開）',
    toast: '出力する項目を現場で検討中のため、もう少しお待ちください。',
    pending: true,
    icon: (
      <svg className="door-icon" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M8 41 L40 41" />
        <path d="M24 41 C 24 31, 24 25, 24 19" />
        <path d="M24 25 C 18 23, 14.5 17, 15.5 11" />
        <path d="M24 21 C 30 19, 34 13, 33 7" />
      </svg>
    ),
  },
  {
    key: 'hocchoken',
    title: 'ほおっちょけん',
    desc: '地域相談窓口の当番表と相談記録',
    screen: 'hocchoken',
    icon: (
      <svg className="door-icon" viewBox="0 0 48 48" fill="currentColor" stroke="none">
        <path d="M14 34 C 14 27, 19 24, 24 24 C 29 24, 34 27, 34 34 C 34 39.5, 29.5 42, 24 42 C 18.5 42, 14 39.5, 14 34 Z" />
        <ellipse cx="18" cy="13" rx="3.3" ry="4.3" />
        <ellipse cx="30" cy="13" rx="3.3" ry="4.3" />
        <ellipse cx="9.5" cy="21" rx="3" ry="4" transform="rotate(-30 9.5 21)" />
        <ellipse cx="38.5" cy="21" rx="3" ry="4" transform="rotate(30 38.5 21)" />
      </svg>
    ),
  },
  {
    key: 'reports',
    title: '各種報告書',
    desc: '出張報告書など、様式どおりのWordを出力します',
    screen: 'reports',
    icon: (
      <svg className="door-icon" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M13 6 L29 6 L35 12 L35 42 L13 42 Z" />
        <path d="M29 6 L29 12 L35 12" />
        <path d="M18 22 L30 22 M18 28 L30 28 M18 34 L26 34" />
      </svg>
    ),
  },
];

/** ログイン後の用途選択画面。準備済みのタイルは画面遷移し、未着手のものはトーストで案内する。 */
export default function HomeScreen({ onNavigate }) {
  const [toast, setToast] = useState({ show: false, message: '' });
  const toastTimer = useRef(null);

  function showToast(message) {
    clearTimeout(toastTimer.current);
    setToast({ show: true, message });
    toastTimer.current = setTimeout(() => setToast((t) => ({ ...t, show: false })), 2600);
  }

  function handlePress(e, door) {
    e.currentTarget.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(.97)' }, { transform: 'scale(1)' }],
      { duration: 200, easing: 'ease-out' }
    );
    if (door.screen) {
      onNavigate(door.screen);
    } else if (door.toast) {
      showToast(door.toast);
    }
  }

  return (
    <div className="hub">
      <div className="hub-head reveal r1">
        <img className="icon" src={heartIcon} width="94" height="96" alt="社会福祉法人 ザ・ハート・クラブ" />
        <img className="org-mark" src={orgWordmark} width="279" height="96" alt="社会福祉法人 ザ・ハート・クラブ" />
        <span className="brand">記録ノート</span>
      </div>

      <p className="greeting reveal r2">今日はどちらを作成しますか？</p>

      <div className="doors">
        {DOORS.map((door, i) => (
          <button
            key={door.key}
            type="button"
            className={`door reveal r${i + 3}${door.pending ? ' is-pending' : ''}`}
            aria-disabled={door.pending || undefined}
            onClick={(e) => handlePress(e, door)}
          >
            {door.pending && <span className="pending-badge">準備中</span>}
            {door.icon}
            <span className="door-title-wrap">
              <span className="door-title">{door.title}</span>
              {UNDERLINE}
            </span>
            <span className="door-desc">{door.desc}</span>
          </button>
        ))}
      </div>

      <div className="hub-kanri-links">
        <button type="button" className="admin-link" onClick={() => onNavigate('kanri-edit')}>管理者編集</button>
        <span className="hub-kanri-sep" aria-hidden="true">・</span>
        <button type="button" className="admin-link" onClick={() => onNavigate('kanri-code')}>管理者コード</button>
      </div>

      <div className={`toast${toast.show ? ' show' : ''}`} role="status" aria-live="polite">
        {toast.message}
      </div>
    </div>
  );
}
